import React, { useEffect } from 'react';
import { FiX } from 'react-icons/fi';

interface Props {
    icon: React.ReactNode;
    title: string;
    sub: string;
    note?: string;
    wide?: boolean;
    className?: string; // extra class on the dialog, for a page-specific width / layout
    onClose: () => void;
    buttons: React.ReactNode;
}

// the Communications pop-up look (CampaignModals.scss .campaign-modal) with a wide variant for Add a Contact
const ContactsModal: React.FC<Props> = ({ icon, title, sub, note, wide, className, onClose, buttons, children }) => {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    return <div className="campaign-modal-overlay" onClick={onClose}>
        <div className={`campaign-modal contacts-modal${wide ? ' wide' : ''}${className ? ` ${className}` : ''}`} role="dialog" aria-modal="true" aria-label={title} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
                <span className="icon">{icon}</span>
                <div className="t"><strong>{title}</strong><span>{sub}</span></div>
                <button type="button" className="close" aria-label="Close" onClick={onClose}><FiX /></button>
            </div>
            <div className="modal-body">{children}</div>
            <div className="modal-footer">
                <span className="note">{note}</span>
                <button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
                {buttons}
            </div>
        </div>
    </div>;
};

export default ContactsModal;
